/// <reference types="@angular/localize" />

import { bootstrapApplication, provideClientHydration } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ErrorHandler,
  importProvidersFrom,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideToastr } from 'ngx-toastr';
import { AppInitService } from './app/app-init.service';
import { initializeApp } from './app/app-initializer';
import { provideState, provideStore } from '@ngrx/store';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideAnimations } from '@angular/platform-browser/animations';
import { GlobalErrorhandelerService } from './app/core/services/global-errorhandeler.service';
import { customInterceptorInterceptor } from './app/core/Interceptor/custom-interceptor.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  provideNativeDateAdapter,
  MatNativeDateModule,
} from '@angular/material/core';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_DATE_FORMATS } from './app/Shared/Models/MY_DATE_FORMATS';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DatePipe } from '@angular/common';
import { async, ReplaySubject, Subject } from 'rxjs';
import { authReducer } from './app/store/reducers/store-reducer';
//import { MY_DATE_FORMATS } from './app/Shared/Components/usr-date-range/usr-date-range.component';
// bootstrapApplication(AppComponent, appConfig).catch((err) =>
//   console.error(err)
// );
bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptors([customInterceptorInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideStore(),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    provideStore({ auth: authReducer }),
    provideMomentDateAdapter(MY_DATE_FORMATS), // ✅ Registers DateAdapter using Moment.js

    importProvidersFrom(
      ReactiveFormsModule,
      MatDatepickerModule,
      MatFormFieldModule,
      MatInputModule,
      MatNativeDateModule,
      ReplaySubject,
      Subject
    ),
    AppInitService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitService],
      multi: true,
    },
    { provide: ErrorHandler, useClass: GlobalErrorhandelerService },
    provideAnimations(), // required animations providers
    provideToastr(),
    provideAnimationsAsync(),
    DatePipe, provideClientHydration(), // Toastr providers
  ],
}).catch((err) => console.error(err));
